import { useState } from '../../hooks'
import { isPortalError, ManageableConnectwareLicense, PortalError } from '../../../../domain'

export const useLicense = (id: string): PortalError | ManageableConnectwareLicense | null =>
    useState((s) => {
        const licenses = s.manageLicenses?.licenses || []
        return isPortalError(licenses) ? licenses : licenses.find((item) => item.id === id) || null
    })
